import { Template } from "./template.js";

const Page6_phones = {
  name: "page6_phones",

  data() {
    return {
      new_phone: null,
      deleting_phone: null,
      editing_phone: null,
      key_phone: null,
      strJSON: "",
      phones: [],
      fields: [
        {
          key: "name",
          label: this.$t("phoneList.employee"),
        },
        {
          key: "phone",
          label: this.$t("phoneList.phone"),
        },
      ],
      types: [
        {
          key: "name",
          info: "",
          typefield: "text",
          namelabel: this.$t("phoneList.employeeName"),
        },
        {
          key: "phone",
          info: "",
          typefield: "text",
          namelabel: this.$t("phoneList.phoneNumber"),
        },
        {
          key: "position",
          info: "",
          typefield: "text",
          namelabel: this.$t("phoneList.position"),
        },
        {
          key: "email",
          info: "",
          typefield: "text",
          namelabel: this.$t("phoneList.email"),
        },
      ],
      options: [],
      default_phone: false,
      message: "",
    };
  },

  created() {
    this.getPhones();
  },

  computed: {
    locale() {
      return this.$i18n.locale;
    },
  },

  updated() {
    this.fields[0].label = this.$t("phoneList.employee");
    this.fields[1].label = this.$t("phoneList.phone");
    this.types[0].namelabel = this.$t("phoneList.employeeName");
    this.types[1].namelabel = this.$t("phoneList.phoneNumber");
    this.types[2].namelabel = this.$t("phoneList.position");
    this.types[3].namelabel = this.$t("phoneList.email");
  },

  methods: {
    showModal(item) {
      this.options = [];
      this.key_phone = item.phone;
      this.default_phone = false;
      this.$refs["EditModal"].show();
      this.options.push({
        key: "name",
        namelabel: this.$t("phoneList.employeeName"),
        typefield: "text",
        info: item.name,
      });
      for (let key in item.info) {
        this.options.push({
          key: key,
          namelabel: this.$t(`phoneList.${key}`),
          typefield: "text",
          info: item.info[key],
        });
      }
      this.default_phone = item.status == 1 ? true : false;
    },

    hideModal() {
      this.$refs["EditModal"].hide();
    },

    showCreateModal() {
      this.$refs["CreateModal"].show();
    },

    hideCreateModal() {
      this.$refs["CreateModal"].hide();
    },

    showDeleteModal(item) {
      this.editing_phone = item;
      this.message = "Вы действительно хотите удалть сотрудника?";
      this.$refs["deleteModal"].show();
    },

    hideDeleteModal() {
      this.$refs["deleteModal"].hide();
    },

    getPhones() {
      var cont = this;
      cont.phones = [];
      this.$API(
        "static_data",
        "phones",
        {},
        function (data) {
          cont.phones = data;
          let nameFields = [];
          // let i = 0;
          for (var key1 in data[0].info) {
            var str = "info." + key1;
            // nameFields.push({key: str, label: key1});
            nameFields.push({ key: str, label: cont.$t(`phoneList.${key1}`) });
            // cont.fields.push(nameFields[i]);
            // cont.$set(cont.fields, cont.fields.length - 1, nameFields[i]);
            // i++;
          }
          // cont.fields.push({ key: "action", label: "" });
          // cont.fields.push({ key: "delete", label: "" });
          nameFields.push({ key: "action", label: "" });
          nameFields.push({ key: "delete", label: "" });

          cont.fields = [cont.fields[0], cont.fields[1], ...nameFields];
        },
        function (errorText) {
          console.log(errorText);
        }
      );
    },

    createPhone() {
      let cont = this;
      cont.new_phone = {
        name: cont.types[0].info,
        phone: cont.types[1].info,
        position: cont.types[2].info,
        email: cont.types[3].info,
        status: this.default_phone ? 1 : 0,
      };
      cont.strJSON = JSON.stringify(cont.new_phone);
      this.types.forEach((element) => {
        element.info = "";
      });
      this.$API(
        "phones",
        "editPhones",
        { phone: cont.strJSON, edit_mode: "create" },
        function (data) {
          cont.$emit("addPhoneToTable", cont.new_phone);
          cont.new_phone = null;
          cont.strJSON = "";
          cont.getPhones();
        },
        function (errorText) {
          console.log(errorText);
        }
      );
      this.hideCreateModal();
    },

    editPhone(fields) {
      let cont = this;
      this.editing_phone = {
        name: fields[0].info,
        phone: this.key_phone,
        position: fields[1].info,
        email: fields[2].info,
        status: this.default_phone == true ? 1 : 0,
      };
      cont.strJSON = JSON.stringify(this.editing_phone);
      this.$API(
        "phones",
        "editPhones",
        { phone: cont.strJSON, edit_mode: "edit" },
        function (data) {
          cont.deleting_phone = null;
          cont.strJSON = "";
          cont.getPhones();
        },
        function (errorText) {
          console.log(errorText);
        }
      );
      this.hideModal();
    },

    deletePhone() {
      let item = this.editing_phone;
      this.editing_phone = null;
      let cont = this;
      cont.deleting_phone = {
        name: item.name,
        phone: item.phone,
        position: item.info.position,
        email: item.info.email,
        status: item.status == true ? 1 : 0,
      };
      cont.strJSON = JSON.stringify(this.deleting_phone);
      this.$API(
        "phones",
        "editPhones",
        { phone: cont.strJSON, edit_mode: "remove" },
        function (data) {
          cont.deleting_phone = null;
          cont.strJSON = "";
          cont.getPhones();
        },
        function (errorText) {
          console.log(errorText);
        }
      );
      this.hideDeleteModal();
    },
  },

  watch: {
    locale() {
      this.getPhones();
    },
  },
  template: Template,
};
export { Page6_phones };



// WEBPACK FOOTER //
// ./src/app/js/components/page6_phones/component.js